import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	viewBox: "0 0 16 16",
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m9.58578644 8-5.29289322 5.2928932c-.39052429.3905243-.39052429 1.0236893 0 1.4142136s1.02368927.3905243 1.41421356 0l6.00000002-6.00000002c.3905243-.39052429.3905243-1.02368927 0-1.41421356l-6.00000002-6c-.39052429-.39052429-1.02368927-.39052429-1.41421356 0s-.39052429 1.02368927 0 1.41421356z",
		fill: "#2b2b2b"
	})
});
export default SvgChevronRight;
